import { useQuery } from '@tanstack/react-query'
import { DriverDayInfo, getDriverDayInfo } from './api'

type Props = {
  companyId: string
  driverId: number
  /** YYYY-MM-DD */
  date: string
}

export const driverDayInfoKey = ({ companyId, driverId, date }: Props) => [
  'driverDayInfo',
  companyId,
  driverId,
  date,
]

export function useQueryDriverDayInfo(props: Props) {
  return useQuery<DriverDayInfo>({
    queryKey: driverDayInfoKey(props),
    enabled: !!props.companyId && !!props.driverId && !!props.date,
    queryFn: async () => (await getDriverDayInfo(props)).data,
  })
}
